import {BTCWalletAdapter} from "../WalletAdapter";
import matchlog from "../../utils/matchlog";

export class LeatherAdapter implements BTCWalletAdapter {
    name = "Leather Wallet";
    website="https://leather.io/"
    walletKey="leather"

    async isInstalled() {
        return typeof window.LeatherProvider !== "undefined";
    }

    async connect(): Promise<string> {
        if (!await this.isInstalled()) throw new Error("Leather Wallet is not installed");
        const response = await window.LeatherProvider?.request("getAddresses");

        matchlog.log("Addresses:", response.result.addresses);

        return response.result.addresses[0].address
    }

    async signMessage(message: string): Promise<string> {
        if (!await this.isInstalled()) throw new Error("Leather Wallet is not installed");
        const response = await window.LeatherProvider?.request("signMessage", {message})
        matchlog.log("response", response)
        return response.result.signature
    }
}
